import { render, staticRenderFns } from "./SlotCounterStationDiscountPromotion.vue?vue&type=template&id=728696ce&"
import script from "./SlotCounterStationDiscountPromotion.vue?vue&type=script&lang=js&"
export * from "./SlotCounterStationDiscountPromotion.vue?vue&type=script&lang=js&"
import style0 from "./SlotCounterStationDiscountPromotion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('728696ce')) {
      api.createRecord('728696ce', component.options)
    } else {
      api.reload('728696ce', component.options)
    }
    module.hot.accept("./SlotCounterStationDiscountPromotion.vue?vue&type=template&id=728696ce&", function () {
      api.rerender('728696ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Counter/SlotCounterStationDiscountPromotion.vue"
export default component.exports